import {
  getAccessToken,
  getOktaAccessToken,
  shouldRenewAccessToken,
} from './localStorage';
import i18n from '@app/i18n';

const secureRequest = async (url, options) =>
  fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      'Accept-Language': i18n.language || 'en',
      // Do NOT move this ternary into a helper function
      // because nested Promises with Redux dispatch can delay API calls.
      // Safe to refactor only after migrating away from Redux.
      Authorization: shouldRenewAccessToken()
        ? await getAccessToken()
        : getOktaAccessToken(),
    },
    ...(options.body &&
      typeof options.body === 'object' && {
        body: JSON.stringify(options.body),
      }),
  });

export default secureRequest;
